import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { ApplicationSubmittedDialogData, ApplicationSubmittedDialogResult } from '@portal-workspace/grow-shared-library';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';


@Component({
    templateUrl: './application-submitted.dialog.html',
    styleUrls: ['./application-submitted.dialog.scss'],
    standalone: true,
    imports: [FlexModule, MatButtonModule, MatDialogModule]
})
export class ApplicationSubmittedDialog {

  constructor(@Inject(MAT_DIALOG_DATA) data: ApplicationSubmittedDialogData,
              private dialogRef: MatDialogRef<ApplicationSubmittedDialog>) {
  }

  onSubmit($event: Event) {
    const result: ApplicationSubmittedDialogResult = {}
    this.dialogRef.close(result);
  }
}
